<div *ngIf="route.children.length === 0">
    <span *ngIf="userInfo?.ifAnyGranted([roles.registrarStaff, roles.registrarAdmin])=== true">
        <div class="row small-up-1 medium-up-3 large-up-4 home-boxes">
            <div *ngIf="userInfo?.ifAnyGranted([roles.registrarAdmin])=== true" class="column"><a
                    [routerLink]="['/home/registrar/maintenance']" class="no-sprite">
                <mat-icon color="primary">settings</mat-icon>
                <div>Maintenance</div>
            </a></div>
            <div *ngIf="userInfo?.ifAnyGranted([roles.registrarAdmin, roles.registrarStaff]) === true"
                 class="column"><a
                    [routerLink]="['/home/registrar/ip-grade']" class="no-sprite">
                <mat-icon color="primary">assignment</mat-icon>
                <div>IP Grading</div>
            </a></div>
            <div *ngIf="userInfo?.ifAnyGranted([roles.registrarAdmin, roles.registrarStaff]) === true" class="column"><a
                    [routerLink]="['/home/registrar/reports']" class="no-sprite">
                <mat-icon color="primary">list</mat-icon>
                <div>Report</div>
            </a></div>
        </div>
    </span>

</div>
<router-outlet></router-outlet>